export default __webpack_public_path__ + "static/media/jenny_hayes.50e9c33c.jpg";